export default __webpack_public_path__ + "src/resources/unknownBarcodeSound.mp3";